import React from 'react'
import {ModulePanel, ModuleHeader, ModuleBody} from 'containers/purchase/modules/module_panel'
import {ListGroup} from 'reactstrap'
import ListItemOption from 'ui/list_item_option'
import { useField, useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import cn from 'classnames'
import time from 'i18n/time'

const PaymentModule = ({...props}) => {
  const { t, i18n } = useTranslation()
  const [field, meta] = useField(props)
  const {setFieldValue} = useFormikContext()
  const {payment_methods} = props.user
  const {expires_at} = props.cart

  // TODO: Dependencia del orden en el cliente. Se debe trasladar al backend

  const paymentMethodsOrder = [1, 2, 13, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16, 17, 18, 19, 20, 21]

  const sortedPaymentMethods = paymentMethodsOrder.map(id => payment_methods.find(item => item.id === id)).filter(item => item !== undefined)

  return (
    <ModulePanel>
      <ModuleHeader status="active" showIcon={false}>
        <span>
          <i className="fa fa-credit-card me-2" aria-hidden="true"></i>
          {i18n.t('payment_module.payment_title')}
        </span>
      </ModuleHeader>
      <ModuleBody status="active" className={{}}>
        <ListGroup>
          {sortedPaymentMethods.map(({code, title, label, label_es, label_en}) =>
            <ListItemOption
              key={code}
              active={field.value === code}
              onClick={() => setFieldValue(field.name, code)}
            >
              <div className="mb-1">
                <div style={{fontSize: '1.2em'}}>
                  <i className="fa fa-arrow-right me-2" style={{visibility: field.value !== code ? 'hidden' : ''}}></i>
                  <strong>
                    {i18n.language === 'es' ? label_es : label_en}
                  </strong>

                  {code === 'amex' &&
                    <i className='ms-2 fab fa-cc-amex'/>
                  }

                  {code === 'generic_credit_card' &&
                    <>
                      <i className='ms-2 fab fa-cc-visa'/>
                      <i className='ms-2 fab fa-cc-mastercard'/>
                      <i className='ms-2 fab fa-cc-amex'/>
                    </>
                  }

                  {[
                    'safe_credit_card',
                    'paygold',
                    'redsys_santander_1',
                    'redsys_santander_2',
                    'redsys_santander_3',
                    'redsys_santander_4'
                  ].includes(code) &&
                    <>
                      <i className='ms-2 fab fa-cc-visa'/>
                      <i className='ms-2 fab fa-cc-mastercard'/>
                      <i className='ms-2 fab fa-cc-amex'/>
                    </>
                  }
                </div>

                {code === 'paygold' &&
                  <div className="ps-4">
                    <i>{i18n.t('payment_module.paygold_expiration_alert', {expiration: time(expires_at).format('LLL')})}</i>
                  </div>
                }

                {code === 'cash' &&
                  <div className="ps-4">
                    <i>{i18n.t('payment_module.cash_expiration_alert')}</i>
                  </div>
                }
              </div>
            </ListItemOption>
          )}
        </ListGroup>
      </ModuleBody>
    </ModulePanel>
  )
}

export default PaymentModule
